import { render } from "./MdRipple.vue?vue&type=template&id=53ec0f64"
import script from "./MdRipple.vue?vue&type=script&lang=js"
export * from "./MdRipple.vue?vue&type=script&lang=js"

import "./MdRipple.vue?vue&type=style&index=0&id=53ec0f64&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__